var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.19532 0.302517C0.755721 0.418571 0.35832 0.759703 0.143794 1.19579C0.0136719 1.45603 0.0136719 1.46307 0.0136719 1.89915C0.0136719 2.32117 0.0171887 2.34931 0.12621 2.57438C0.185996 2.7045 0.312602 2.89441 0.407556 2.99288C0.632632 3.23555 8.15159 8.25756 8.43997 8.35604C8.70373 8.44747 9.29456 8.44747 9.55832 8.35604C9.8467 8.25756 17.3657 3.23555 17.5907 2.99288C17.6857 2.89441 17.8123 2.7045 17.8721 2.57438C17.967 2.37041 17.9846 2.29304 17.9952 1.98004C18.0092 1.68463 17.9987 1.58616 17.9354 1.39625C17.7525 0.85114 17.3199 0.439672 16.7889 0.299C16.606 0.253281 15.7128 0.246247 8.98156 0.249764C2.44731 0.249764 1.3571 0.256798 1.19532 0.302517Z",
    fill: "#16171B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.00245101 8.27163L0.0130015 12.5375L0.143124 12.8013C0.29083 13.1002 0.551075 13.3851 0.82187 13.5398C1.21575 13.7649 0.66713 13.7508 8.99848 13.7508C15.7086 13.7508 16.6054 13.7438 16.7882 13.6981C17.3158 13.5574 17.7518 13.1459 17.9312 12.6114C18.0015 12.3969 18.0015 12.3406 17.9945 8.2013L17.984 4.00925L14.1858 6.54488C12.0968 7.93754 10.2997 9.1227 10.1942 9.17546C9.72646 9.41812 9.07233 9.51659 8.55888 9.42867C7.99267 9.3302 7.99618 9.3302 3.91667 6.61169C1.8101 5.20848 0.062237 4.04442 0.0376192 4.03035C0.00245101 4.00925 -0.00458263 4.8357 0.00245101 8.27163Z",
    fill: "#16171B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ad79ffcc9da2e9fe68f50cc168b85fb4.svg";
export { ForwardRef as ReactComponent };